import {fetchAtClientSide} from "../../../utils/misc/fetchClient";

export const ssoConfigurations = async (): Promise<any> => {
    let url = `configurations/web`;
    return await fetchAtClientSide({url});
};
